import styled from 'styled-components';

const LogoMiddleNavBar = styled.img`
  width: 100px;
  height: 50px;
  object-fit: cover;
`

export { LogoMiddleNavBar };